// extracted by mini-css-extract-plugin
export default {"wrapper":"HomePage_wrapper_Npagk","content":"HomePage_content_tK37Y","logo":"HomePage_logo_JBBIz","duck":"HomePage_duck_KBDcT"};